import { InjectionToken } from '@angular/core';

/** Shape of the file scripts/version-info.js generates per app at build time. */
export interface VersionInfo {
  version: string;
  buildTime: string;
  timestamp: string;
  tag: string;
}

/** Each app provides its own generated versionInfo in app.config: { provide: VERSION_INFO, useValue: versionInfo }. */
export const VERSION_INFO = new InjectionToken<VersionInfo>('VERSION_INFO');
